//@flow
import type { HProps } from "./H";
import type { BaseComponentProps } from "../base-component/BaseComponent";
import * as React from "react";
import { Text, View, ScrollView, Image } from "react-native";
import H from "./H";

export type H4Props = HProps & {};
export type H4State = {};

export const H4Style = {
  fontSize: 12
};

export default class H4 extends React.Component<H4Props, H4State> {
  render() {
    return <H {...this.props} style={{ ...H4Style, ...this.props.style }}>{this.props.children}</H>;
  }
}
